import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

import {
  JavascriptLogo,
  JestLogo,
  NodeLogo,
  PostgresLogo,
  ReactLogo,
} from "../Icons";

import Tech from "./Tech";

function TechList() {
  const myRef = useRef();
  const [reveal, setReveal] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setReveal(entry.isIntersecting);
    });
    observer.observe(myRef.current);
  }, []);

  return (
    <Container ref={myRef} className={reveal ? 'show' : 'hidden'}>
      <Title>technologies</Title>
      <Tech
        color="#d4cd68"
        name="Javascript"
        type="Language"
        icon={<JavascriptLogo height={30} />}
        useCase="core language"
      />
      <Tech
        color="#6dcdc1"
        name="React"
        type="Framework"
        icon={<ReactLogo height={32} />}
        useCase="component creation"
      />
      <Tech
        color="#6ea76d"
        name="Node"
        type="Runtime, Backend"
        icon={<NodeLogo height={32} />}
        useCase="server-side spelunking"
      />

      <Tech
        color="#6888d4"
        name="PostgreSQL"
        type="Database"
        icon={<PostgresLogo height={32} />}
        useCase="persistant data storage"
      />
      <Tech
        color="#ec9366"
        name="Jest"
        type="Testing"
        icon={<JestLogo height={32} />}
        useCase="application testing"
      />
    </Container>
  );
}

export default TechList;

const Container = styled.div`
  height: auto;
  padding: 20px 48px;
  margin-top: 20px;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin: 50px 0px;
  text-align: center;
`;
